export function productPath(product) {
  const key = product?.slug || product?.id;
  return key ? "/product/" + encodeURIComponent(key) : "/search/all";
}
